import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "component-variable-list-v2 component-variable-list--masonry"
};
import MasonryList from "src/shared/v-components/ui/masonry/MasonryList.vue";
import { categorizeComponentVariables } from "..";
import { computed, toRef } from "vue";
import ComponentVariable from "../../item/ComponentVariable.vue";
import { isComponentVariablePrimaryCategoryShown, isComponentVariableSecondaryCategoryShown, isComponentVariableShown, isComponentVariableSecondaryCategoryDisplayNameShown, } from "../filter/isComponentVariableShown";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import { useComponentVariableSearchables } from "src/shared/store/component-variable-searchable/composables/useComponentVariableSearchables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableListMasonry',
    props: {
        componentMutableKey: {},
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        const { componentMutable } = useComponentMutable(toRef(props, "componentMutableKey"));
        const componentId = computed(() => {
            var _a;
            return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.component_id;
        });
        const { componentVariableSearchables } = useComponentVariableSearchables(componentId);
        const categorizedVariables = computed(() => {
            return categorizeComponentVariables(componentVariableSearchables.value);
        });
        const toMasonryItem = (variable) => {
            return {
                id: variable.name,
                isShown() {
                    return isComponentVariableShown(variable.name, props.componentMutableKey);
                },
            };
        };
        const toMasonryItems = (secondaryCategory) => {
            const items = [];
            secondaryCategory.variables.basic.forEach((variable) => {
                items.push(toMasonryItem(variable));
            });
            secondaryCategory.variables.advanced.forEach((variable) => {
                items.push(toMasonryItem(variable));
            });
            return items;
        };
        return (_ctx, _cache) => {
            return (componentId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorizedVariables.value, (primaryCategory) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                            class: "component-variable-list__primary-category",
                            key: primaryCategory.name
                        }, [
                            _createElementVNode("h1", null, _toDisplayString(primaryCategory.getDisplayName()), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryCategory.secondaryCategories, (secondaryCategory) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                    class: "component-variable-list__primary-category__secondary-category",
                                    key: secondaryCategory.name
                                }, [
                                    _withDirectives(_createElementVNode("h2", null, _toDisplayString(secondaryCategory.getDisplayName()), 513 /* TEXT, NEED_PATCH */), [
                                        [_vShow,
                                            _unref(isComponentVariableSecondaryCategoryDisplayNameShown)(primaryCategory.secondaryCategories.length === 1, secondaryCategory.getDisplayName())
                                        ]
                                    ]),
                                    _createVNode(MasonryList, {
                                        items: toMasonryItems(secondaryCategory),
                                        "negative-margin": 16
                                    }, {
                                        item: _withCtx((item) => [
                                            _createVNode(ComponentVariable, {
                                                "component-id": componentId.value,
                                                "variable-name": item.id,
                                                "component-mutable-key": _ctx.componentMutableKey,
                                                componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                                            }, null, 8 /* PROPS */, ["component-id", "variable-name", "component-mutable-key", "componentDrawerRouteConfig"])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                                ])), [
                                    [_vShow,
                                        _unref(isComponentVariableSecondaryCategoryShown)(secondaryCategory.name, _ctx.componentMutableKey)
                                    ]
                                ]);
                            }), 128 /* KEYED_FRAGMENT */))
                        ])), [
                            [_vShow,
                                _unref(isComponentVariablePrimaryCategoryShown)(primaryCategory.name, _ctx.componentMutableKey)
                            ]
                        ]);
                    }), 128 /* KEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
